<template>
  <!-- review page-->
  <div class="page-margin">
    <!--breadcrumb start-->
    <div class="breadcrumb-bg">
      <div class="container">
        <div class="row">
          <div class="col-md-6 col-sm-6 d-align-center">
            <h2 class="title"><span> Review</span></h2>
          </div>
          <div class="col-md-6 col-sm-6">
            <nav aria-label="breadcrumb" class="theme-breadcrumb">
              <ol class="breadcrumb bg-transparent mb-0">
                <li class="breadcrumb-item">
                  <router-link target="_blank" :to="{ name: 'Index' }"
                    >Home</router-link
                  >
                </li>
                <li class="breadcrumb-item active"><a href="#">Review</a></li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
    </div>
    <!--breadcrumb end -->

    <!-- review Section start -->
    <section class="review-block blog-page">
      <div class="container">
        <div class="row margin-bottom">
          <div class="col-lg-4 col-md-6">
            <div class="review-box">
              <img
                src="../assets/images/review.png"
                alt="review"
                class="img-fluid"
              />
              <h5>John Martin</h5>
              <div class="rating-star">
                <i class="fa fa-star" aria-hidden="true"></i>
                <i class="fa fa-star" aria-hidden="true"></i>
                <i class="fa fa-star" aria-hidden="true"></i>
                <i class="fa fa-star" aria-hidden="true"></i>
                <i class="fa fa-star" aria-hidden="true"></i>
              </div>
              <div class="review-message">
                <p>
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever since the 1500s
                </p>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6">
            <div class="review-box">
              <img
                src="../assets/images/review.png"
                alt="review"
                class="img-fluid"
              />
              <h5>John Martin</h5>
              <div class="rating-star">
                <i class="fa fa-star" aria-hidden="true"></i>
                <i class="fa fa-star" aria-hidden="true"></i>
                <i class="fa fa-star" aria-hidden="true"></i>
                <i class="fa fa-star" aria-hidden="true"></i>
                <i class="fa fa-star" aria-hidden="true"></i>
              </div>
              <div class="review-message">
                <p>
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever since the 1500s
                </p>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6">
            <div class="review-box">
              <img
                src="../assets/images/review.png"
                alt="review"
                class="img-fluid"
              />
              <h5>John Martin</h5>
              <div class="rating-star">
                <i class="fa fa-star" aria-hidden="true"></i>
                <i class="fa fa-star" aria-hidden="true"></i>
                <i class="fa fa-star" aria-hidden="true"></i>
                <i class="fa fa-star" aria-hidden="true"></i>
                <i class="fa fa-star" aria-hidden="true"></i>
              </div>
              <div class="review-message">
                <p>
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever since the 1500s
                </p>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6">
            <div class="review-box">
              <img
                src="../assets/images/review.png"
                alt="review"
                class="img-fluid"
              />
              <h5>John Martin</h5>
              <div class="rating-star">
                <i class="fa fa-star" aria-hidden="true"></i>
                <i class="fa fa-star" aria-hidden="true"></i>
                <i class="fa fa-star" aria-hidden="true"></i>
                <i class="fa fa-star" aria-hidden="true"></i>
                <i class="fa fa-star" aria-hidden="true"></i>
              </div>
              <div class="review-message">
                <p>
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever since the 1500s
                </p>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6">
            <div class="review-box">
              <img
                src="../assets/images/review.png"
                alt="review"
                class="img-fluid"
              />
              <h5>John Martin</h5>
              <div class="rating-star">
                <i class="fa fa-star" aria-hidden="true"></i>
                <i class="fa fa-star" aria-hidden="true"></i>
                <i class="fa fa-star" aria-hidden="true"></i>
                <i class="fa fa-star" aria-hidden="true"></i>
                <i class="fa fa-star" aria-hidden="true"></i>
              </div>
              <div class="review-message">
                <p>
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever since the 1500s
                </p>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6">
            <div class="review-box">
              <img
                src="../assets/images/review.png"
                alt="review"
                class="img-fluid"
              />
              <h5>John Martin</h5>
              <div class="rating-star">
                <i class="fa fa-star" aria-hidden="true"></i>
                <i class="fa fa-star" aria-hidden="true"></i>
                <i class="fa fa-star" aria-hidden="true"></i>
                <i class="fa fa-star" aria-hidden="true"></i>
                <i class="fa fa-star" aria-hidden="true"></i>
              </div>
              <div class="review-message">
                <p>
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever since the 1500s
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="animation-circle absolute">
        <i></i>
        <i></i>
        <i></i>
      </div>
      <div class="animation-circle-inverse">
        <i></i>
        <i></i>
        <i></i>
      </div>
    </section>
    <!-- review Section End -->
    <!--Footer Section start-->
    <Copyright />
    <!--Footer Section End-->
  </div>
  <!-- end review page-->
</template>
<script>
export default {
  name: "Review",
  beforeCreate: function () {
    document.body.className = "inner-page";
  },
};
</script>
